import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import Spinner from 'react-bootstrap/Spinner';
import Unavailable from '../../components/unavailable';
import { useContent } from '../../content/ContentProvider';
import Picture, { SIZES } from '../../components/picture';
import { imageSize } from '../../content/imageUrl';
import styles from './styles.module.scss';

export default function FineArtsDetailPage() {

    const { id } = useParams();
    const navigate = useNavigate();
    const [loadedWide, setLoadedWide] = useState(false);
    const { status, fineArts } = useContent();

    const image = fineArts.find((item) => item.id.toString() === id);

    // The layout depends on the shape of the first picture. It is known up
    // front; a picture of unknown size tells when it has loaded.
    const firstSize = image ? imageSize(image.images[0]) : null;
    const isWide = firstSize ? firstSize[0] > firstSize[1] : loadedWide;

    // const navigateToContact = () => {
    //     navigate('/contact');
    // }

    const handleImageLoad = (e) => {
        const { naturalWidth, naturalHeight } = e.target;
        setLoadedWide(naturalWidth > naturalHeight);
      };

    if (status === 'loading') {
        return (
          <div className="col-12 m-auto d-flex flex-column align-items-center justify-content-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Laster inn...</span>
            </Spinner>
          </div>
        );
    }
    if (status === 'error') {
        return <Unavailable />;
    }

    if (!image) {
        return (
          <div className="col-12 d-flex flex-column align-items-center justify-content-center">
            <h2>Bildet ble ikke funnet</h2>
            <button onClick={() => navigate('/store')}>Tilbake til Butikk</button>
          </div>
        );
      }
    return(
        <div className="col-12 px-3 px-md-5 pb-5 d-flex flex-column flex-md-row justify-content-center" >
            {/* <div className="col-12 m-sm-auto col-md-4 me-md-5"> */}
            {/* <div className={`col-12 ${isWide ? 'col-md-6 ms-md-5' : 'col-md-4'} me-md-5`}>
                <Image fluid alt="detail-image" src={image.url} onLoad={handleImageLoad}/>
            </div> */}
            <div className={`col-12 d-flex flex-column align-items-center ${isWide ? 'col-md-6 ms-md-5 ms-auto' : 'col-md-4'} ms-md-auto 
            
            `}>
              {image.images.map((picture, index) => (
                <div key={index} className="mb-4">
                  <Picture
                    image={picture}
                    sizes={isWide ? SIZES.fineArtWide : SIZES.fineArtTall}
                    quality="detail"
                    priority={index === 0}
                    alt={`detail-image-${index}`}
                    onLoad={index === 0 ? handleImageLoad : undefined}
                  />
                </div>
              ))}
            </div>
            <div className="col-sm-10 col-md-5 ms-md-5 ps-md-5 text-black">
                <h1 className={`mb-md-5 mb-sm-3 mt-5 ${isWide ? 'col-md-6' : 'col-md-4'}`}>{image.name}</h1>
                <ul>
                    <li>Limited edition print</li>
                    <li>Signed and numbered</li>
                    <li>Giclée print on Hahnemühle paper</li>
                    <li>Can be ordered as print or framed</li>
                    <li>Different sizes available</li>
                </ul>
                {/* <div className={`${styles.navigateLink} col-6 col-md-4 my-md-5 my-sm-5`} onClick={navigateToContact}>PURCHASE</div> */}
                {/* <div
                  className={`${styles.navigateLink} col-6 col-md-4 my-md-5 my-sm-5`}
                  onClick={() => {
                    window.location.href = 'mailto:foto.jurgis@gmail.com';
                  }}
                >
                  PURCHASE
                </div> */}
                <div
                  className={`${styles.navigateLink} col-6 col-md-4 my-md-5 my-sm-5`}
                  onClick={() => {
                    const subject = encodeURIComponent(`Purchase inquiry: ${image.name}`);
                    const body = encodeURIComponent(
                      `Hi,\n\nI would like to purchase the fine art print "${image.name}".\n\nBest regards,`
                    );

                    window.location.href = `mailto:foto.jurgis@gmail.com?subject=${subject}&body=${body}`;
                  }}
                >
                  PURCHASE
                </div>
            </div>
        </div>
    )
}